import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Source, Layer, Marker, Popup } from "react-map-gl";
import { generateKey } from "../services/mapTile";
import { Typography, Card, CardContent, Grid } from "@material-ui/core";

const styles = (theme) => ({
  popup: {
    zIndex: 2,
    marginTop: "-50px",
  },
  marker: {
    zIndex: 1,
  },
  popupContent: {
    width: "650px",
  },
  infoImage: {
    width: "100%",
  },
  infoRow: {
    borderBottom: "solid #ccc 1px",
    paddingBottom: "5px",
    paddingTop: "5px",
  },
  infoTitle: {
    width: "30%",
    display: "inline-block",
    verticalAlign: "top",
  },
  infoDesciption: {
    width: "70%",
    display: "inline-block",
    verticalAlign: "top",
  },
  infoLeftBox: {
    marginTop: "10px",
    border: "solid #ccc 1px",
    borderRight: "none",
  },
  infoRightBox: {
    marginTop: "10px",
    border: "solid #ccc 1px",
  },
  subTitle: {
    fontWeight: "bold",
    marginTop: "10px",
  },
  infoUrlContainer: {
    marginTop: "10px",
  },
  infoUrl: {
    marginTop: "15px",
    paddingLeft: "5px",
    paddingRight: "5px",
    borderRight: "1px solid #ccc",
  },
});

class Routing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: generateKey("routing"),
      isShowPopup: false,
      popups: {},
    };
  }
  _onMarkerClick = (event, idx) => {
    console.log(" marker click");
    if (event.nativeEvent) {
      event.nativeEvent.preventDefault();
      event.nativeEvent.stopPropagation();
    }
    event.preventDefault();
    event.stopPropagation();

    const { popups } = this.state;
    popups[idx] = true;
    this.setState({
      popups: popups,
    });
  };

  _onClosePopup = (idx) => {
    const { popups } = this.state;
    popups[idx] = false;
    this.setState({
      popups: popups,
    });
  };

  render() {
    const { data, classes } = this.props;
    const { id, popups } = this.state;
    if (!data) return null;
    const { geojson, lineColor, lineWidth, markers } = data;

    return (
      <div>
        <Source id={id} type="geojson" data={geojson} />,
        <Layer
          id={id}
          type="line"
          source={id}
          layout={{
            "line-join": "round",
            "line-cap": "round",
          }}
          paint={{
            "line-color": lineColor ? lineColor : "#d234eb",
            "line-width": lineWidth ? lineWidth : 8,
          }}
        />
        {markers
          ? markers.map((marker, idx) => (
              <div key={idx}>
                <div>
                  { (marker.data && popups[idx]) ? (
                    <Popup
                      className={classes.popup}
                      tipSize={5}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      longitude={marker.longitude}
                      latitude={marker.latitude}
                      closeOnClick={false}
                      onClose={() => this._onClosePopup(idx)}
                    >
                      <Card className={classes.popupContent}>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="h2"
                            className={classes.title}
                          >
                            {marker.data.title}
                          </Typography>
                          <Grid container spacing={3}>
                            <Grid item xs={4} className={classes.infoLeftBox}>
                              {marker.data.imageUrl ? (
                                <img
                                  className={classes.infoImage}
                                  alt=""
                                  src={marker.data.imageUrl}
                                ></img>
                              ) : null}
                              {marker.data.subTitle ? (
                                <div className={classes.subTitle}>
                                  {marker.data.subTitle}
                                </div>
                              ) : null}

                              {marker.data.urls ? (
                                <div className={classes.infoUrlContainer}>
                                  {marker.data.urls.map((urlData, index) => (
                                    <a
                                      key={index}
                                      className={classes.infoUrl}
                                      alt={urlData.title}
                                      href={urlData.url}
                                      target="blank"
                                    >
                                      {urlData.title}
                                    </a>
                                  ))}
                                </div>
                              ) : null}
                            </Grid>

                            <Grid item xs={8} className={classes.infoRightBox}>
                              {marker.data.lables
                                ? marker.data.lables.map((lableData, index) => {
                                    return (
                                      <div
                                        className={classes.infoRow}
                                        key={index}
                                      >
                                        <div className={classes.infoTitle}>
                                          {lableData.title}
                                        </div>
                                        <div className={classes.infoDesciption}>
                                          {lableData.description}
                                        </div>
                                      </div>
                                    );
                                  })
                                : null}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Popup>
                  ) : null}
                </div>
                <Marker
                  key={idx}
                  longitude={marker.longitude}
                  latitude={marker.latitude}
                  width="50"
                  height="50"
                  offsetTop={-50}
                  offsetLeft={-10}
                  captureClick={true}
                  className={classes.marker}
                >
                  {marker.toolTip ? (
                    <span className="map-marker-tooltip">{marker.toolTip}</span>
                  ) : null}

                  <div>
                    <img
                      src={marker.iconUrl}
                      className="leaflet-marker-icon grow"
                      alt=""
                      onClick={(event) => this._onMarkerClick(event, idx)}
                    />
                  </div>
                </Marker>
              </div>
            ))
          : null}
      </div>
    );
  }
}
export default withStyles(styles)(Routing);
